:host {
  display: block;
  margin: 0;
}

form {
  display: flex;
  flex-direction: column;
  gap: var(--size-4);
}

input {
  outline: var(--pos-input-outline);
  padding: var(--scale-000);
  border: none;
  border-radius: var(--radius-xs);
  width: var(--size-full);
  box-sizing: border-box;
  background: var(--pos-input-background-color);
  color: var(--pos-normal-text-color);
}

input:focus-within {
  outline: var(--pos-input-focus-outline);
}

input#login {
  outline: none;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  color: var(--pos-primary-text-color);
  background-color: var(--pos-primary-color);
}

input#login:disabled {
  cursor: default;
  color: var(--pos-disabled-text-color);
  background-color: var(--pos-disabled-color);
  box-shadow: none;
}

input#login:hover:not(:disabled),
input#login:focus {
  filter: brightness(110%);
  box-shadow: var(--shadow-md);
}

label.remember-me {
  display: flex;
  align-items: center;
  gap: var(--size-2);
  cursor: pointer;
}

label.remember-me input[type='checkbox'] {
  margin: 0;
  appearance: none;
  padding: var(--size-2);
  width: var(--size-2);
  height: var(--size-2);
  border-radius: var(--radius-xs);
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
}

label.remember-me input[type='checkbox']:checked {
  background-color: var(--pos-primary-color);
  border-color: var(--pos-primary-color);
}

label.remember-me input[type='checkbox']:checked::after {
  content: '';
  position: absolute;
  inset: 0;
  margin: auto;
  width: 3px;
  height: 6px;
  border: solid white;
  border-width: 0 1.5px 1.5px 0;
  transform: translateY(-1px) rotate(45deg);
}

label.remember-me input[type='checkbox']:focus {
  outline: 2px solid var(--pos-primary-color);
  outline-offset: 2px;
}
